:host {
  display: block;
}

h3 {
  font-family:'Lato';
  font-weight:'regular';
  line-height:115%;
  font-size:51px;
  letter-spacing:1;
  text-decoration:none;
}